'use client'
import Script from 'next/script'

export function ThemeInitScript() {
  const code = `
    (function() {
      try {
        var theme = localStorage.getItem('theme');
        if (!theme) {
          theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
          localStorage.setItem('theme', theme);
        }
        var root = document.documentElement;
        root.setAttribute('data-theme', theme);
        if (theme === 'dark') {
          root.classList.add('dark');
        } else {
          root.classList.remove('dark');
        }
        document.documentElement.style.visibility = 'visible';
      } catch (e) {
        console.error('Theme init failed', e);
      }
    })();
  `;
  return <Script id="theme-init" strategy="beforeInteractive" dangerouslySetInnerHTML={{ __html: code }} />;
}
